var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBlockingIssuesCount)?_c(_vm.tag,{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],tag:"component",attrs:{"title":_vm.__('Blocking issues')}},[_c('gl-icon',{attrs:{"name":"entity-blocking","variant":"warning"}}),_vm._v("\n  "+_vm._s(_vm.blockingIssuesCount)+"\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }